import styled from "styled-components";

export const CondimentSkeletonStyled = styled.div`
  .condiment-skeleton {
    &__list {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
      grid-gap: 0.75rem; /* To define the gap between rows/columns */
      gap: 0.75rem;
    }
    &__item {
      height: 180px;
    }
  }
`;
